<script lang="ts" setup>
import Alert from '~/components/Common/Alert/Alert.vue'

interface Props {
	show?: boolean
	title?: string
	message?: string
	cancel?: {
		text?: string
	}
	confirm?: {
		text?: string
	}
}

const props = withDefaults(defineProps<Props>(), {
	show: false,
	title: 'Are you sure?',
	message: 'Are you sure you want to delete this item?',
	cancel: {
		text: 'Cancel',
	},
	confirm: {
		text: 'OK',
	},
})

const emits = defineEmits(['close', 'confirmed'])

const buttons = [
	{
		text: props.confirm.text,
		role: 'confirm',
		handler: () => {
			emits('confirmed')
		},
		btnClass: 'btn-error',
	},
	{
		text: props.cancel.text,
		role: 'cancel',
		handler: () => {
			emits('close')
		},
		btnClass: 'btn-muted',
	},
]
</script>
<template>
<Alert
	:show="show"
	icon="ph:warning-duotone"
	:title="title"
	:message="message"
	:buttons="buttons"
	type="error"
/>
</template>
